import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Box, Skeleton, Stack, Tooltip, Typography } from '@mui/material'

import {
  COLOR_REALLOCATION_PRIMARY,
  COLOR_REALLOCATION_TEXT_SECONDARY,
} from 'components/reports/Metrics/constants/AllocationStability'

interface Props {
  summaryCount: number
  summaryTotal: number
  loading?: boolean
}

export const ReAllocatedJobsStat = ({ summaryCount, summaryTotal, loading }: Props) => (
  <Box sx={{ p: 3, flex: 1, textAlign: 'center' }}>
    <Stack direction='row' spacing={0.5} alignItems='center' justifyContent='center' mb={1.5}>
      <Typography variant='subtitle2' color={COLOR_REALLOCATION_PRIMARY}>
        Re-allocated Jobs
      </Typography>
      <Tooltip
        title='A job is counted as re-allocated if it was allocated to one supplier and later allocated to a different supplier. Only the latest re-allocation per job is counted.'
        placement='top'>
        <Box sx={{ display: 'flex', color: 'text.disabled', cursor: 'help' }}>
          <InfoOutlinedIcon sx={{ fontSize: 22, color: COLOR_REALLOCATION_PRIMARY }} />
        </Box>
      </Tooltip>
    </Stack>

    {loading ? (
      <Skeleton width={100} height={60} sx={{ mx: 'auto' }} />
    ) : (
      <Typography
        variant='h2'
        fontWeight={700}
        sx={{ color: COLOR_REALLOCATION_PRIMARY, lineHeight: 1, mb: 0.75 }}>
        {summaryCount.toLocaleString()}
      </Typography>
    )}

    <Typography variant='caption' color={COLOR_REALLOCATION_TEXT_SECONDARY}>
      out of {loading ? '—' : summaryTotal.toLocaleString()} total jobs
    </Typography>
  </Box>
)
